import { render, staticRenderFns } from "./aS.vue?vue&type=template&id=497e3c5d&"
import script from "./aS.vue?vue&type=script&lang=js&"
export * from "./aS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports